/* eslint-disable */
import 'jcarousel';

import Search from "@/js/common/Domain/Service/Search";
import TourCriteriaObjectValue from "@/js/common/Domain/ObjectValue/TourCriteria";
import imageProxy from "@/js/common/Domain/Service/imageProxy";
import toRouterHotelHydrator from "@/js/common/Domain/Hydrator/toRouterHotel";
import searchSessionService from "@/js/common/Domain/Service/search/searchSession";
import HotelsRepository from "@/js/common/Domain/Repository/Hotels";
import HotelFactory from "@/js/common/Domain/Factory/Hotel";
import HotelsMapView from "@/js/desktop/components/hotelsMap/HotelsMap";
import SearchRequestFactory from "@/js/common/Domain/Factory/SearchRequest";
import getMultipleHotelPhotosService from "@/js/common/Domain/Service/getMultipleHotelPhotos";
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';

import HotelOnMapView from '@/js/desktop/components/hotelOnMap/hotelOnMap';

const hotelOnMapView = new HotelOnMapView();
let searchService = new Search();
const showcasePath = getShowcasePath();

var currentTourCritria = new TourCriteriaObjectValue();

var mapHotel = Backbone.View.extend({
	el:'<div class="serpHotel serpHotel_new"></div>',
	template:null,
	events: {
		"click .goToHotelWithId": "goToHotelWithId",
		"click .goToHotel": "goToHotel",
		"mousedown a:not(.goto-ua-page)": 'hrefUrl'
	},
	getImages:function() {
		var images = this.model.get('imagesHtml'),
			self = this,
			html,
			hotelId = this.model.get('id'),

			photosAjaxSuccess = function(response) {
				var limit,
					result = response[hotelId];
				limit = result.photos.length > 2 ? 2 : result.photos.length;
				html = '<li><a href="#" style="background-image: url(' + imageProxy(result.cover ? result.cover : '', {
					width: 300,
					height: 220
				}) + ')"></a></li>';
				for (var i = 0; i < limit; i++) {
					html += '<li><a href="#" style="background-image: url(' + imageProxy(result.photos[i], {
						width: 300,
						height: 220
					}) + ')"></a></li>';
				}
				self.model.set('imagesHtml', html);
				$('.imagesHtml', self.$el).html(html);
				self.model.set('cover', result.cover);
				self.model.set('photos', result.photos);

				$('.js-images-carousel', this.$el).jcarousel('reload', {
					animation: 'fast',
					vertical:  false
				});
			};

		if(!images) {
			getMultipleHotelPhotosService({
				hotels: hotelId
			},{
				success: photosAjaxSuccess,
				error: () => {}
			});
		}
	},

    render() {
        const data = this.model.toJSON({ computed: true });
        data.originalHotelObject = this.model;

        hotelOnMapView.reRender({
            data,
            $el: this.$el,
            parentModel: this.model,
            collectionView: this.collectionView,
        });

        $('.js-images-carousel', this.$el)
            .jcarousel({
                list: '.list',
                items: 'li',
                wrap: 'both',
                vertical: false,
            });

        $('.js-images-carousel-control-prev', this.$el)
            .jcarouselControl({
                target: '-=1',
            });

        $('.js-images-carousel-control-next', this.$el)
            .jcarouselControl({
                target: '+=1',
            });

        this.data = data;
    },

    reRender() {
        this.render();
    },

	initSubscribes:function() {
		this.model.on('change:minPrice', $.proxy(this.reRender, this));
		this.model.on('change:tourProducts', $.proxy(this.reRender, this));
	},

    initialize(options) {
        this.collectionView = options.collectionView;
        this.template = options.template;

        this.render();
        this.initSubscribes();

        this.getImages();
    },

	hrefUrl: function(event){
		var urlParams = toRouterHotelHydrator({
				tourCriteria:mapSearchPageModel.get('searchData'),
				sid:searchSessionService.getSearchId()
			}),

			hotelUrl = showcasePath + '/hotel/' + this.model.get('id'),
			target = '_blank',
			$target = $(event.currentTarget);


		$(event.currentTarget).attr('href', hotelUrl + '#?' + $.param(urlParams));
		$(event.currentTarget).attr('target', target);
	},
	goToHotel:function(event) {
		var tourCriteria = this.model.get('tourProducts').at(0).get('tourCriteria'),
			urlParams = toRouterHotelHydrator({
				tourCriteria:tourCriteria,
				sid:searchSessionService.getSearchId()
			}),
			target = '_blank',
			hotelUrl = showcasePath + '/hotel/' + this.model.get('id');

		if (this.model.hotelType && this.model.hotelType == "current") {
			$(document).scrollTop($('#hotelToursList').offset().top-100);
		} else {
			window.open(hotelUrl + '#?' + $.param(urlParams), target);
		}

		return false;
	}
});

var mapSearchPageModel = new (Backbone.Epoxy.Model.extend({
	defaults: {
		searchData: currentTourCritria,
		beforeToursLoading:true,
		loadingInProgress: false,
		viewMode:'map',
		syncHotels:null,
		syncTourProducts:null,
		sortStrategy:"recommend"
	},
	computeds:{
		filteredHotels:function() {
			return this.get('syncHotels');
		},
		minPrice: function () {
			var hotels = this.get('syncHotels'),
				minPrice = Infinity;

			if (hotels && hotels.length) {
				hotels.each(function (hotel) {
					var price = hotel.get('minPrice');
					if (price < minPrice) {
						minPrice = price;
					}
				});
				return minPrice;
			} else {
				return false;
			}
		}
	}
}))();

var hotelsCollection = new HotelsRepository();

let MapHotelsSearchView = Backbone.Epoxy.View.extend({
	model: mapSearchPageModel,
	collection: hotelsCollection,
	itemView: mapHotel,
	currentSearchModel: new TourCriteriaObjectValue(),
	currentHotel:null,
	parentView: null,

	initialize: function(options) {
		var self = this,
			tourProduct;

		if(appConfig.coordinates) {
			this.currentHotel = new HotelFactory(_.extend({}, window.appConfig.hotelInfo, {
				map:appConfig.coordinates
			}));
			this.currentHotel.hotelType = "current";
			this.parentView = options.parentView;
			this.parentView.model.set('mapHotelsSearchModel', this.model);

			this.initMapOpenEvent();
		}
	},
	initMapOpenEvent: function() {
		var self = this,
			$hideBtn = $(".js-hide-map-btn"),
			$openMap = $('#openMap'),
			mapOpened = false;

		$openMap.on('click', function(event) {
			$openMap.hide();
			$hideBtn.show();

			$('#showMapContainer').slideDown("fast", !mapOpened ? function() {
				self.initEvents();
				self.tourSearchCriteriaChanged();
				mapOpened = true;
			} : '');
		});
		$hideBtn.on("click",function () {
			$('#showMapContainer').slideUp("fast");
			$hideBtn.hide();
			$openMap.show();
		})


	},
	initEvents:function() {
		this.listenTo(this.parentView.model, 'change:tourSearchCriteria', $.proxy(this.tourSearchCriteriaChanged, this));
	},
	openCurrentHotelMap:function() {
		var hotels;

		this.collection.reset();
		hotels = new HotelsRepository(this.currentHotel);

		this.model.set('syncHotels', hotels);
		this.model.trigger('change:filteredHotels', null, this.model.get('filteredHotels'));
		this.model.set('loadingInProgress', false);
		this.initMap();
	},
	tourSearchCriteriaChanged:function() {
		var tourSearchCriteria = this.parentView.model.get('tourSearchCriteria');

		if(tourSearchCriteria) {
			tourSearchCriteria = tourSearchCriteria.clone();
			tourSearchCriteria.set('hotels', new HotelsRepository());

			this.currentSearchModel.set(tourSearchCriteria.attributes);
			this.goSearch();
		} else {
			this.openCurrentHotelMap();
			this.hotelsMap.openFirstHotelInfo();
		}
	},

	goSearch:function() {
		var searchServiceParamsCollection = [],
			tourCriteria = this.currentSearchModel,
			self = this;

		if(tourCriteria.isValid() && tourCriteria.get('countries') && tourCriteria.get('countries').length) {
			this.model.set('searchData', tourCriteria);
			searchServiceParamsCollection.push(new SearchRequestFactory(tourCriteria, 'sync'));

			self.model.set('loadingInProgress', true);
			this.openCurrentHotelMap();
			this.hotelsMap.initMap(function() {
				self.hotelsMap.openFirstHotelInfo();
			});
			searchService.getTours({
				requests: searchServiceParamsCollection,
				callback: {
					sync: function (hotels, tourProducts) {
						var currentHotel = hotels.findWhere({id: window.appConfig.hotelInfo.id});
						hotels.each(function (hotel) {
							hotel.initHotelOptions();
						});

						if (hotels.length > 0) {
							self.collection.reset();
						}

						if (currentHotel) {
							currentHotel.hotelType = 'current';
							hotels.remove(currentHotel, {silent: true});
							hotels.unshift(currentHotel, {silent: true});
						} else {
							hotels.unshift(self.currentHotel, {silent: true});
						}

						self.hotelsMap.initMap(function () {
							self.hotelsMap.tryOpenFirstHotelInfo();
						});
						self.model.set('syncHotels', hotels, {
							setFirstOnCenter: true
						});
						self.model.set('syncTourProducts', tourProducts);
						/*self.model.trigger('change:filteredHotels', null, self.model.get('filteredHotels'));*/
						self.model.set('loadingInProgress', false);
					}
				}
			});
		}
	},

    initMap() {
        if (!this.hotelsMap) {
            this.hotelsMap = new HotelsMapView({
                currentHotel: this.currentHotel,
                hotelMapView: hotelOnMapView,
                searchPageModel: this.model,
                HotelsList: mapHotel,
            });
        }
    },
});

export default MapHotelsSearchView;
